import { ChainId, getChainById, Token } from 'symbiosis-js-sdk'
import type { OmniPool } from '~/pages/CrossChainFarmPageV2/types'
import { OMNIPOOL_CONFIG } from './config'
import { symbiosis } from '~/lib/symbiosis'

const ORDER = [
	ChainId.ETH_MAINNET,
	ChainId.ZKSYNC_MAINNET,
	ChainId.ARBITRUM_MAINNET,
	ChainId.OPTIMISM_MAINNET,
	ChainId.BSC_MAINNET,
	ChainId.AVAX_MAINNET,
	ChainId.MATIC_MAINNET,
	ChainId.TELOS_MAINNET,
	ChainId.BOBA_MAINNET,
	ChainId.BOBA_AVALANCHE,
	ChainId.BOBA_BNB,
]

export let omniPools: OmniPool[] | undefined

export function getOmniPools(): OmniPool[] {
	if (omniPools) {
		return omniPools
	}

	const pools: OmniPool[] = []

	const tokens = symbiosis
		.getOmniPoolTokens(symbiosis.config.omniPools[0])
		.sort((a: Token, b: Token) => {
			const indexA = ORDER.indexOf(a.chainFromId || 0)
			const indexB = ORDER.indexOf(b.chainFromId || 0)

			if (indexA === indexB) {
				return 0
			}
			if (indexA === -1) {
				return 1
			}
			if (indexB === -1) {
				return -1
			}
			if (indexA < indexB) {
				return -1
			}
			return 1
		})

	tokens.forEach((token) => {
		const chain = getChainById(OMNIPOOL_CONFIG.chainId)

		if (!chain) {
			return
		}

		pools.push({
			chain,
			id: `${token.symbol} / ${token.chainFromId}`,
			token,
		})
	})

	omniPools = pools

	return pools
}
